<script setup lang="ts">
import Icon from "../../components/icon/icon.vue";
</script>

<template>
  <div class="layout-new-checkout--loading">
    <div class="layout-new-checkout__loader">
      <h2>Laster</h2>
      <Icon type="spinner" size="small" class="icon--spinner mr-2"></Icon>
    </div>
  </div>
</template>
